import React from "react";
import { UserComponent } from "@craftjs/core";
import { BuilderBlock, IBuilderBlockProps } from "../BuilderBock/BuilderBlock";
import { PageSettings } from "./PageSettings";
import { StyleSettings } from "../../../editor/stylePanel";
import { defaultStyleProps } from "../BuilderBock/BuilderBlock.styles";

export interface IPageProps extends IBuilderBlockProps {
  title: string;
  children: React.ReactNode;
}

const defaultProps: Omit<IPageProps, "children"> = {
  title: "Untitled",
  padding: ["0", "0", "0", "0"],
  margin: ["0", "0", "0", "0"],
  backgroundColor: { r: 255, g: 255, b: 255, a: 1 },
  width: "100%",
  height: "100%",
  minHeight: "50px",
};

export const Page: UserComponent<Partial<IPageProps>> = ({
  title,
  children,
  ...rest
}) => {
  return <BuilderBlock {...rest}>{children}</BuilderBlock>;
};

Page.craft = {
  displayName: "Page",
  props: defaultProps,
  related: {
    toolbar: PageSettings,
    styles: StyleSettings,
  },
};

Page.defaultProps = { ...defaultStyleProps };
